import { FC, PropsWithChildren } from "react";

export const HotspotContent: FC<PropsWithChildren> = ({ children }) => {
	return <div>{children}</div>;
};
